<template>
  <div>
    <DeleteModal modalId="modal-staff-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-staff-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('surgery.Surgery Staff')
          : $t('surgery.Edit Surgery Staff')
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col lg="4">
            <AutoComplete
              :label="$t('surgery.Surgery Staff')"
              :placeholder="$t('surgery.Surgery Staff')"
              v-model="EditForm.employee_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="employees"
              text-title="full_name"
            />
          </b-col>
          <b-col lg="4">
            <b-form-group :label="$t('common.type')" label-for="Type">
              <v-select
                v-model="EditForm.anesthetist_type"
                :options="[
                  { text: 'Anaesthetist', value: '0' },
                  { text: 'Anaesthetist Asiistant', value: '1' },
                  { text: 'Nurse', value: '2' },
                ]"
                :reduce="(action) => action.value"
                label="text"
                :placeholder="$t('common.type')"
              />
            </b-form-group>
          </b-col>
          <!-- <b-col lg="4">
            <b-form-group :label="$t('common.price')" label-for="Price">
              <b-form-input
                id="price"
                type="number"
                v-model="EditForm.price"
                :placeholder="$t('common.price')"
              />
            </b-form-group>
          </b-col> -->
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card no-body class="staff-card">
      <b-card-header class="section-header">
        <div
          class="d-flex justify-content-between align-items-center header-actions-wrapper"
        >
          <h5 class="mb-0">
            <feather-icon icon="UsersIcon" size="18" class="mr-2" />
            {{ $t("surgery.Surgery Staff") }}
          </h5>
          <b-button
            variant="primary"
            size="sm"
            @click="show(EditForm, 'create')"
          >
            <feather-icon icon="PlusIcon" size="14" class="mr-1" />
            {{ $t("common.add") }}
          </b-button>
        </div>
      </b-card-header>
      <b-card-body>
        <div v-if="data && data.length > 0" class="modern-cards-grid">
          <div v-for="staff in data" :key="staff.id" class="modern-card">
            <div class="modern-card-header">
              <div class="modern-card-icon">
                <feather-icon icon="UserIcon" size="24" class="text-info" />
              </div>
              <div class="modern-card-title">
                {{ staff.employee ? staff.employee.full_name : "N/A" }}
              </div>
            </div>
            <div class="modern-card-content"></div>
            <div class="modern-card-footer">
              <b-badge
                :variant="
                  staff.anesthetist_type == 0
                    ? 'primary'
                    : staff.anesthetist_type === 1
                    ? 'warning'
                    : 'success'
                "
              >
                {{
                  staff.anesthetist_type == 0
                    ? "Anaesthetist"
                    : staff.anesthetist_type === 1
                    ? "Anaesthetist Assistant"
                    : "Nurse"
                }}
              </b-badge>
            </div>
            <div
              class="modern-card-footer"
              style="border-top: none; padding-top: 0.5rem"
            >
              <ActionsButtons
                deletePerm="delete-surgery"
                editPerm="update-surgery"
                :noDelete="true"
                @editToggle="show(staff)"
                @deleteToggle="deleteModel(staff)"
              />
            </div>
          </div>
        </div>
        <div v-else class="no-data-empty">
          <feather-icon icon="UsersIcon" size="48" class="empty-icon" />
          <p>{{ $t("common.no-data-available") }}</p>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BBadge,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import vSelect from "vue-select";
import { props } from "vue-prism-component";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";

export default {
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BCardHeader,
    BCardBody,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    BBadge,
    AutoComplete,
    Datepicker,
    vSelect,
  },

  props: ["patientCardId", "doctorSurgeryId", "staff", "getData"],

  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      surgeryId: null,
      surgery: {},
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_surgery_id: "",
        employee_id: "",
        anesthetist_type: "",
        price: 0,
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        patient_card_surgery_id: "",
        employee_id: "",
        anesthetist_type: "",
        price: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "employee",
          label: this.$t("common.Full Name"),
          sortable: true,
        },
        {
          key: "anesthetist_type",
          label: this.$t("common.type"),
          sortable: true,
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },

  mounted() {
    this.data = this.staff;
  },
  watch: {
    staff(newValue) {
      this.data = newValue;
    },
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.surgeryId = null;
        this.createMode = true;
        this.EditForm = {
          patient_card_surgery_id: this.doctorSurgeryId,
          employee_id: "",
          anesthetist_type: "",
          price: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.patient_card_surgery_id = this.doctorSurgeryId;
        this.EditForm.employee_id = item.employee_id;
        this.EditForm.price = item.price;
        item.anesthetist_type = item.anesthetist_type;
        // this.EditForm.anesthetist_type =
        // item.anesthetist_type == 0
        //   ? [{ text: "Anaesthetist", value: item.anesthetist_type }]
        //   : item.anesthetist_type == 1
        //   ? [{ text: "Anaesthetist Asiistant", value: item.anesthetist_type }]
        //   : [{ text: " Nurse", value: item.anesthetist_type }];

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-staff-edit");
    },

    // async getDoctorAssistantsList() {
    //   this.loading = true;

    //   let url = `surgery-staff?page=${this.page}&take=${this.take}&sort=-id&include=employee`;

    //   await this.getList(url);
    //   this.dataCount = this.all_data.total;
    //   this.data = this.all_data.data;
    //   this.loading = false;
    // },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-staff-delete");
    },
    formatDate(date) {
      if (date) {
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `surgery-staff/${this.deleteForm.id}`)
        .then((response) => {
          // this.getDoctorAssistantsList();
          this.$emit("getData");

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.price = 0;

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `surgery-staff`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              // this.getDoctorAssistantsList();
              this.$emit("getData");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `surgery-staff/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              // this.getDoctorAssistantsList();
              this.$emit("getData");
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.staff-card {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.section-header {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.625rem 1rem;
  display: flex;
  align-items: center;

  h5 {
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

  .header-actions-wrapper {
    width: 100%;
    gap: 1rem;
  }
}

// Modern Cards Grid
.modern-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

.modern-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  padding: 1.25rem;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}

.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.modern-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.modern-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modern-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  flex: 1;
  line-height: 1.3;
}

.modern-card-content {
  flex: 1;
  margin-bottom: 1rem;
}

.modern-card-footer {
  display: flex;
  align-items: center;
  padding-top: 0.75rem;
  border-top: 1px dashed #cbd5e1;
  gap: 0.5rem;
}

.no-data-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  color: #94a3b8;
}

.no-data-empty .empty-icon {
  opacity: 0.3;
  margin-bottom: 1rem;
}

.no-data-empty p {
  margin: 0;
  font-size: 1rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
